import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LandmarkIcon } from 'lucide-react';
import { GlassCard } from './GlassCard';
import { depositRates } from '../data/bankData';
const PAGE_SIZE = 6;
const CYCLE_MS = 7000;
export function DepositRates() {
  const pages = Math.ceil(depositRates.length / PAGE_SIZE);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setPage(p => (p + 1) % pages);
    }, CYCLE_MS);
    return () => clearInterval(id);
  }, [pages]);
  const start = page * PAGE_SIZE;
  const visibleRows = depositRates.slice(start, start + PAGE_SIZE);
  const rows: ((typeof depositRates)[number] | null)[] = [...visibleRows, ...Array(Math.max(0, PAGE_SIZE - visibleRows.length)).fill(null)];
  return <GlassCard delay={0.35} className="p-6 relative flex flex-col" data-id="element-31">
      <div className="flex items-center justify-between mb-4" data-id="element-32">
        <div className="flex items-center gap-3" data-id="element-33">
          <div className="flex items-center justify-center h-12 w-12 rounded-lg bg-[#0066B3] border border-white/15" data-id="element-34">
            <LandmarkIcon className="h-6 w-6 text-white" data-id="element-35" />
          </div>
          <div data-id="element-36">
            <div className="text-[12px] uppercase text-white/70 font-semibold" data-id="element-37">
              Savings &amp; Term
            </div>
            <div className="tracking-display text-2xl font-bold text-white leading-tight" data-id="element-38">
              Fixed Deposit Rates
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-39">
          <div className="text-[12px] uppercase text-white/80 font-semibold" data-id="element-40">
            % per annum
          </div>
          <div className="text-[11px] text-white/55" data-id="element-41">LKR · Min. LKR 5,000</div>
        </div>
      </div>

      <div className="grid grid-cols-12 px-4 pb-2 text-[12px] uppercase text-white/65 font-semibold border-b border-white/15" data-id="element-42">
        <div className="col-span-4" data-id="element-43">Tenure</div>
        <div className="col-span-3 text-right" data-id="element-44">Rate</div>
        <div className="col-span-3 text-right" data-id="element-45">AER</div>
        <div className="col-span-2 text-right" data-id="element-46">Senior</div>
      </div>

      <div className="relative flex-1 overflow-hidden mt-2" data-id="element-47">
        <AnimatePresence mode="wait" data-id="element-48">
          <motion.div key={page} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.35
        }} className="h-full flex flex-col" data-id="element-49">
            {rows.map((d, i) => <motion.div key={`${page}-${i}`} initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: d ? 1 : 0,
            x: 0
          }} exit={{
            opacity: 0,
            x: 16
          }} transition={{
            delay: i * 0.06,
            duration: 0.45,
            ease: [0.22, 1, 0.36, 1]
          }} className="grid grid-cols-12 items-center px-4 flex-1 min-h-0" style={{
            borderBottom: i < PAGE_SIZE - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none'
          }} data-id="element-50">
                {d ? <>
                    <div className="col-span-4 text-[18px] text-white font-medium" data-id="element-51">
                      {d.tenure}
                    </div>
                    <div className="col-span-3 text-right font-mono-num text-[22px] font-bold text-white" data-id="element-52">
                      {d.rate.toFixed(2)}%
                    </div>
                    <div className="col-span-3 text-right font-mono-num text-[22px] font-bold text-[#9ed957]" data-id="element-53">
                      {d.aer.toFixed(2)}%
                    </div>
                    <div className="col-span-2 text-right font-mono-num text-[18px] font-bold text-amber-300" data-id="element-54">
                      {d.senior?.toFixed(2)}%
                    </div>
                  </> : <div className="col-span-12 h-full" data-id="element-55" />}
              </motion.div>)}
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="mt-3 pt-2 border-t border-white/10 flex items-center justify-between" data-id="element-56">
        <span className="text-[11px] uppercase text-white/55" data-id="element-57">
          Senior 60+ yrs
        </span>
        <div className="flex items-center gap-1.5" data-id="element-58">
          {Array.from({
          length: pages
        }).map((_, i) => <motion.span key={i} animate={{
          width: i === page ? 22 : 8,
          backgroundColor: i === page ? '#7FB539' : 'rgba(255,255,255,0.3)'
        }} transition={{
          duration: 0.4
        }} className="h-1.5 rounded-full" data-id="element-59" />)}
        </div>
        <span className="text-[11px] uppercase text-white/55" data-id="element-60">combank.lk</span>
      </div>
    </GlassCard>;
}